// Copyright 2018 Sorama B.V.

import { Unit, UnitType } from "./Unit";

export class Phase extends UnitType {
    public static override typeName = "Phase";

    public static degree: Unit = new Unit("°", 1 / 360.0, Phase);
    public static radian: Unit = new Unit("rad", 1 / (2 * Math.PI), Phase);
}
